import React, { useCallback, useEffect, useState } from 'react';
import { Benefit } from '@/api/products';
import Text from '../Text';

type AppBenefitsProps = {
  benefits: Benefit[];
};

type BenefitsConfig = {
  unlimitedTalks: boolean;
  threeMonthsTalks: boolean;
  unlimitedSocialNetworks: boolean;
  threeMonthsSocialNetworks: boolean;
  [key: string]: boolean;
};
const benefitsConfig: BenefitsConfig = {
  unlimitedTalks: false,
  threeMonthsTalks: false,
  unlimitedSocialNetworks: false,
  threeMonthsSocialNetworks: false,
};
const AppBenefits: React.FC<AppBenefitsProps> = ({ benefits }) => {
  const [showAppBenefits, setShowAppBenefits] = useState(false);
  const [image, setImage] = useState('/talksAndSocialNetworks.svg');
  const [textInfo, setTextInfo] = useState('5GB dedicados');

  const isUnlimited = useCallback((benefitsFounded: BenefitsConfig) => {
    return (
      benefitsFounded.unlimitedTalks || benefitsFounded.unlimitedSocialNetworks
    );
  }, []);
  const hasTalksBenefitApp = useCallback((benefitsFounded: BenefitsConfig) => {
    return benefitsFounded.unlimitedTalks || benefitsFounded.threeMonthsTalks;
  }, []);
  const hasSocialNetworksBenefitApp = useCallback(
    (benefitsFounded: BenefitsConfig) => {
      return (
        benefitsFounded.unlimitedSocialNetworks ||
        benefitsFounded.threeMonthsSocialNetworks
      );
    },
    [],
  );

  useEffect(() => {
    const benefitsFounded = Object.keys(benefitsConfig).reduce(
      (benefit, key) => {
        benefit[key] = !!benefits.find((item) => item.componente === key);
        return benefit;
      },
      {} as BenefitsConfig,
    );
    setShowAppBenefits(
      benefitsFounded.unlimitedTalks ||
        benefitsFounded.threeMonthsTalks ||
        benefitsFounded.unlimitedSocialNetworks ||
        benefitsFounded.threeMonthsSocialNetworks,
    );

    setImage(() => {
      if (
        hasTalksBenefitApp(benefitsFounded) &&
        hasSocialNetworksBenefitApp(benefitsFounded)
      )
        return '/talksAndSocialNetworks.svg';
      if (hasTalksBenefitApp(benefitsFounded)) return '/talks.svg';
      return '/socialNetworks.svg';
    });

    setTextInfo(() => {
      return isUnlimited(benefitsFounded) ? 'inclusos' : '5GB dedicados';
    });
  }, [benefits, hasSocialNetworksBenefitApp, hasTalksBenefitApp, isUnlimited]);

  if (!showAppBenefits) {
    return null;
  }
  return (
    <div className='flex flex-row justify-start lg:flex-col lg:items-end'>
      <img src={image} alt='App beneficios' className='mr-3 lg:mr-0' />
      <Text as='span' kind='gray' size='sm'>
        {textInfo}
      </Text>
    </div>
  );
};

export default AppBenefits;
